{
  "collapse": "Comprimi",
  "expand": "Espandi"
}
